import styled from 'styled-components';

export const Container = styled.div`
  background-color: #f2f4f7;
`;

export const ListCards = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
`;
